<template>
  <div>
    <v-card class="px-9 py-11 pb-3 my-6 mb-3" style="border-radius: 15px">
      <h1>Welcome to the IBA Team</h1>
      <span class="span_one"
        >{{ FirstName }}, welcome to the IBA administrative team. After clicking
        the button below you will have access to the administrative side of the
        IBA website. Remember, with great power comes great responsibility. We
        are glad to have you on board!.</span
      >
      <v-btn block color="#00AAD3" to="/dashboard" class="py-5 my-9"
        ><span class="white--text text_style"> GO TO IBA ADMIN</span></v-btn
      >
    </v-card>
  </div>
</template>

<script>
export default {
  name: "RegisterScreenTwoComponent",
  props: ["FirstName"],
  data() {
    return {
      name: "[First_name]",
    };
  },
};
</script>

<style scoped>
h1 {
  font-family: "DM Sans";
  font-size: 24px;
  font-weight: 500;
  color: #222222;
}
.span_one {
  font-family: "DM Sans";
  font-size: 14px;
  font-weight: 400;
  color: rgba(34, 34, 34, 0.7);
}
.h1_Two {
  font-family: "Merriweather";
  font-size: 24px;
  font-weight: 400;
  line-height: 30px;
}
.h1_Two_span {
  font-family: "DM Sans";
  font-size: 16px;
  font-weight: 400;
  color: #00aad3;
}
</style>
